import { AxiosError } from 'axios';

export interface IApiError {
	message: string;
	statusCode: number | null;
	statusText: string | null;
	stack: string | null;
	data: IApiProblem | string | null;
}

export interface IApiProblem {
	detail: string;
	status: number;
	title: string;
	traceId: string;
	type: string;
}

export const handleApiError = (error: unknown) => {
	if (error instanceof AxiosError) {
		return {
			data: error.response?.data,
			message: error.message,
			stack: error.stack,
			statusCode: error.response?.status,
			statusText: error.response?.statusText
		} as IApiError;
	}
	if (error instanceof Error) {
		return {
			data: null,
			message: error.message,
			stack: error.stack,
			statusCode: null,
			statusText: null
		} as IApiError;
	}
	return error;
};
